export const SET_VIEW_PATH = 'SET_VIEW_PATH';
export const setViewPath = (path) => ({type: SET_VIEW_PATH, payload: path});

export const SET_VIEW = 'SET_VIEW';
export const setView = (documents) => ({type: SET_VIEW, payload: documents});
export const INJECT_VIEW = 'INJECT_VIEW';
export const injectView = (documents) => ({type: INJECT_VIEW, payload: documents});
export const EXTRACT_VIEW = 'EXTRACT_VIEW';
export const extractView = (documents) => ({type: EXTRACT_VIEW, payload: documents});
export const CLEAR_VIEW = 'CLEAR_VIEW';
export const clearView = () => ({type: CLEAR_VIEW});
export const SET_VIEW_CACHE = 'SET_VIEW_CACHE';
export const setViewCache = (cache) => ({type: SET_VIEW_CACHE, payload: cache});

export const SET_VIEW_INDEX = 'SET_VIEW_INDEX';
export const setViewIndex = (documents) => ({type: SET_VIEW_INDEX, payload: documents});
export const CLEAR_VIEW_INDEX = 'CLEAR_VIEW_INDEX';
export const clearViewIndex = () => ({type: CLEAR_VIEW_INDEX});
export const EXTRACT_VIEW_INDEX = 'EXTRACT_VIEW_INDEX';
export const extractViewIndex = (documents) => ({type: EXTRACT_VIEW_INDEX, payload: documents});

export const SET_SUBVIEW = 'SET_SUBVIEW';
export const setSubview = (documents) => ({type: SET_SUBVIEW, payload: documents});
export const INJECT_SUBVIEW = 'INJECT_SUBVIEW';
export const injectSubview = (documents) => ({type: INJECT_SUBVIEW, payload: documents});
export const EXTRACT_SUBVIEW = 'EXTRACT_SUBVIEW';
export const extractSubview = (documents) => ({type: EXTRACT_SUBVIEW, payload: documents});
export const CLEAR_SUBVIEW = 'CLEAR_SUBVIEW';
export const clearSubview = () => ({type: CLEAR_SUBVIEW});
export const SET_SUBVIEW_CACHE = 'SET_SUBVIEW_CACHE';
export const setSubviewCache = (loading) => ({type: SET_SUBVIEW_CACHE, payload: loading});

export const SET_SUBVIEW_INDEX = 'SET_SUBVIEW_INDEX';
export const setSubviewIndex = (documents) => ({type: SET_SUBVIEW_INDEX, payload: documents});
export const CLEAR_SUBVIEW_INDEX = 'CLEAR_SUBVIEW_INDEX';
export const clearSubviewIndex = () => ({type: CLEAR_SUBVIEW_INDEX});



// WEBPACK FOOTER //
// ./src/actions/view.js